/**
 * I passi del protocollo di crisi, mentre si modificano.
 *
 * Logica pura, fuori dal componente: i passi sono per lingua e la schermata ne
 * mostra una alla volta, quindi ogni modifica tocca una sola voce di una sola
 * lingua e le altre devono restare intatte — è la cosa che un'assegnazione in
 * posto sbaglia per prima.
 *
 * Sta in un file `.ts` e non dentro `SupervisionPage.tsx` anche per una ragione
 * meno nobile: il test dei vincoli che cerca il testo scritto nei componenti
 * legge `>...<` come testo JSX, e `Record<string, string[]>` in una firma lo
 * faceva scattare (`docs/DECISIONI.md`, AD3). Il posto giusto per della logica
 * pura era comunque questo.
 */

export type ProtocolSteps = Record<string, string[]>;

export function cloneSteps(source: ProtocolSteps): ProtocolSteps {
  const copy: ProtocolSteps = {};
  for (const [key, value] of Object.entries(source)) copy[key] = [...value];
  return copy;
}

/** Sostituisce (o aggiunge in coda) un passo di una lingua. */
export function withStep(
  source: ProtocolSteps,
  locale: string,
  index: number,
  value: string,
): ProtocolSteps {
  const next = cloneSteps(source);
  const list = next[locale] ?? [];
  list[index] = value;
  next[locale] = list;
  return next;
}

/** Toglie un passo. Gli altri si rinumerano da soli: sono un elenco ordinato. */
export function withoutStep(source: ProtocolSteps, locale: string, index: number): ProtocolSteps {
  const next = cloneSteps(source);
  next[locale] = (next[locale] ?? []).filter((_, position) => position !== index);
  return next;
}
